// extracted by mini-css-extract-plugin
module.exports = {"overAll":"plansandfeatures_overAll__1SUsz","switchFlex":"plansandfeatures_switchFlex__3wMO2","inputHide":"plansandfeatures_inputHide__xZ_eN"};